'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { logErrorBoundaryError } from 'src/core/logger/browser'

export const CmsSectionErrorBoundary = ({
  children,
}: {
  children: React.ReactNode
}) => {
  return (
    <ErrorBoundary
      FallbackComponent={() => null}
      onError={(error) => {
        logErrorBoundaryError(error)
      }}
    >
      {children}
    </ErrorBoundary>
  )
}
